import request from '../request'
import qs from 'query-string'


// 获取物品列表分页
export function getItemListPage(params: any) {
    let query = qs.stringify(params)
    return request.get(`/api/items/page?${query}`)
}

// 新增物品
export function addItem(params: any) {
    return request.post(`/api/items`, params)
}

// 更新物品
export function updateItem(params: any) {
    return request.put(`/api/items`, params)
}

// 删除物品
export function deleteItem(id: number) {
    return request.delete(`/api/items/${id}`)
}
//批量删除物品
export function deleteItemBatch(params: any) {
    return request.post(`/api/items/batch_delete`, params)
}


//获取成分列表分页
export function getIngredListPage(params: any) {
    console.log(123, params)
    let query = qs.stringify(params)
    return request.get(`/api/ingredients/page?${query}`)
}

// 新增成分
export function addIngred(params: any) {
    return request.post(`/api/ingredients`, params)
}

// 更新成分
export function updateIngred(params: any) {
    return request.put(`/api/ingredients`, params)
}

// 删除成分
export function deleteIngred(id: number) {
    return request.delete(`/api/ingredients/${id}`)
}

//批量删除成分
export function deleteIngredBatch(params: any) {
    return request.post(`/api/ingredients/batch_delete`, params)
}




// 获取疾病列表分页
export function getDiseaseListPage(params: any) {
    let query = qs.stringify(params)
    return request.get(`/api/disease/page?${query}`)
}

// 新增疾病
export function addDisease(params: any) {
    return request.post(`/api/disease`, params)
}

// 更新疾病
export function updateDisease(params: any) {
    return request.put(`/api/disease`, params)
}

// 删除疾病
export function deleteDisease(id: number) {
    return request.delete(`/api/disease/${id}`)
}

//批量删除疾病
export function deleteDiseaseBatch(params: any) {
    return request.post(`/api/disease/batch_delete`, params)
}

//批量更新物品或成分是否可食用
export function updateItemOrIngredApi(params: any) {
    return request.post(`/api/batch/modify_item`, params)
}
//批量获取物品或成分是否可食用
export function getItemOrIngredApi(params: any) {
    return request.post(`/api/batch/get_item`, params)
}

// 获取所有物品列表
export function getAllItemList(name?: string) {
    return request.get(`/api/items?name=${name}`)
}

// 获取所有成分列表
export function getAllIngredList(name?: string) {
    return request.get(`/api/ingredients?name=${name}`)
}

//批量移除物品/成分
export function removeItemOrIngred(params: any) {
    return request.post(`/api/disease/batch_remove`, params)
}


//导入
export function importComponent(params: any) {
    return request.post(`/api/excel/component`, params, { headers: { 'Content-Type': 'multipart/form-data' } })
}

//导入
export function importItemOrIngred(params: any) {
    // 如果params已经是FormData类型，直接使用
    if (params instanceof FormData) {
        return request.post(`/api/excel/import`, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    // 如果params包含文件对象，则构建FormData
    if (params.file && params.file instanceof File) {
        const formData = new FormData();
        formData.append('file', params.file);

        // 添加其他参数
        Object.keys(params).forEach(key => {
            if (key !== 'file') {
                formData.append(key, params[key]);
            }
        });

        return request.post(`/api/excel/import`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    // 如果是普通对象，直接发送
    return request.post(`/api/excel/import`, params);
}

